import { CRM_WEB_PAGES_URLS } from '../CRM_WEB_PAGES_URLS';
import { usStates } from '../data';
import { PATIENT_WEB_PAGES_URLS } from '../PATIENT_WEB_PAGES_URLS';
import { defaultOrgConfig } from './default';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const gracemd: OrganizationSettings = defaultOrgConfig(
  'gracemd',
  'Grace MD',
  'gracemd.com'
);

const excludedStates = {
  WV: true,
  KS: true,
  NM: true,
  MS: true,
  LA: true,
  OTHER: true
};

gracemd.patientWebAppLayout.logo.img =
  'https://cdn.prod.website-files.com/630cf5c3fde88d3fa5008ecc/673d6aff9a5cd6110db8c860_GraceMD_logo_horizontal%20(1)%20(2).png';
gracemd.patientWebAppLayout.brand = 'gracemd';
gracemd.blockCreateOrderOnFailedPayment = true;
gracemd.patientWebAppLayout.nmiPublicKey = 'gW5n53-WA29Gc-8KZy2x-8vH667';
gracemd.patientWebAppLayout.privacyPolicyUrl =
  'https://www.gracemd.com/privacy';
gracemd.patientWebAppLayout.termsOfUseUrl =
  'https://www.gracemd.com/terms-service';
gracemd.patientWebAppLayout.mainMenu.push({
  title: 'Subscriptions',
  link: PATIENT_WEB_PAGES_URLS.subscriptions.list,
  svg: 'assets/icons/orders.svg',
  roles: ['*']
});
gracemd.emrWebAppLayout.customerTabs = [
  'sheet',
  'consults',
  'subscriptions',
  'notes',
  'files',
  'rx',
  'credits',
  'payment-methods',
  'orders',
  'coupons',
  'extras',
  'activity'
];
gracemd.patientWebAppLayout.gtm.id = 'GTM-WVCZDBJ3';
gracemd.patientWebAppLayout.availableStates.us = usStates.filter(
  ({ code }) => !excludedStates[code]
);

delete gracemd.pharmacies.Foothills;
delete gracemd.pharmacies.Promise;

gracemd.crmWebAppLayout.mainMenu = [
  {
    title: 'Leads',
    link: CRM_WEB_PAGES_URLS.leads.list,
    icon: 'fa-regular fa-address-book',
    roles: ['*']
  },

  {
    title: 'Tasks',
    link: CRM_WEB_PAGES_URLS.tasks.list,
    icon: 'fa-solid fa-list-check',
    roles: ['*']
  },
  {
    title: 'Segments',
    link: CRM_WEB_PAGES_URLS.segment.list,
    icon: 'fa-solid fa-table-columns',
    roles: ['*']
  },
  {
    title: 'Store Manager',
    link: '',
    icon: 'fas fa-shop',
    roles: ['admin', 'developer', 'owner'],
    items: [
      {
        title: 'Products',
        link: CRM_WEB_PAGES_URLS.products.list,
        icon: 'fas fa-product'
      },
      {
        title: 'Categories',
        link: CRM_WEB_PAGES_URLS.productCategories.list,
        icon: 'fas fa-product'
      },
      {
        title: 'Coupons',
        link: CRM_WEB_PAGES_URLS.coupons.list,
        icon: 'fas fa-product'
      },
      {
        title: 'Promotions',
        link: CRM_WEB_PAGES_URLS.promotions.list,
        icon: 'fas fa-product'
      }
    ]
  },
  {
    title: 'Admin',
    link: '',
    icon: 'fas fa-user-cog',
    roles: ['admin', 'developer', 'owner'],
    items: [
      {
        title: 'Workflows',
        link: CRM_WEB_PAGES_URLS.workflows.list,
        icon: 'fas fa-code-branch'
      },
      {
        title: 'Templates',
        link: CRM_WEB_PAGES_URLS.emailTemplates.list,
        icon: 'fas fa-palette'
      },
      {
        title: 'Users',
        link: CRM_WEB_PAGES_URLS.users.list,
        icon: 'fas fa-lock'
      },
      {
        title: 'Settings',
        link: CRM_WEB_PAGES_URLS.settings.base,
        icon: 'fa-solid fa-sliders'
      }
    ]
  }
];
